import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { EventBus } from '../../../../../shared/event/bus';
import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'admin-apikey-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class AdminApiKeyListComponent extends AbstractListComponent implements OnInit, OnDestroy {

  selectedRowId: number = 0;
  searchChanged: Subject<string> = new Subject<string>();
  private oldRows: any[];

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              eventBus: EventBus,
              changeDetector: ChangeDetectorRef,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route);
  }

  getResourceUrl(): string {
    return '/admin/api-keys';
  }

  ngOnInit() {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Api Keys',
      url: '/api-key',
    });
    this.parameters.limit = 99;
    this.parameters.offset = 0;
    this.parameters.orderBy = 'id';
    this.parameters.orderDir = 'desc';
    this.searchChanged.pipe(
      debounceTime(500),
      distinctUntilChanged(),
    )
      .subscribe(model => {
        this.load();
      });
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onDelete(rowId) {
    if (!rowId) {
      this.load();
    } else {
      this.delete(rowId);
    }
  }

  onAdd() {
    const newRow = {
      id: undefined,
      name: 'API Key',
      policy: ''
    };
    this.pagination.rows.unshift(newRow);
  }

  filterByName($event: any) {
    this.pagination.rows = [];
    this.oldRows = [];
    this.parameters.offset = 0;
    this.searchChanged.next($event);
  }

  loadMore() {
    this.oldRows = [...this.pagination.rows];
    this.parameters.offset += 1;
    this.searchChanged.next(this.parameters.offset + '');
  }
}
